<div class="edition-item" *ngIf="!isEmpty(field.value)" [attr.data-automation-id]="'edition-item-' + field.key">
  <h6 class="edition-item-label">{{ labelFor(field.key) }}</h6>
  <div [ngClass]="isArray(field.value) ? 'edition-item-values' : 'edition-item-value'">
    <ng-container *ngIf="isArray(field.value); else scalar">
      <ng-container *ngFor="let v of field.value;">
        <span *ngIf="field.key === 'format'">{{ customTranslateValue('material-type.', v) }}</span>
        <span *ngIf="field.key.toLowerCase().includes('lang')">{{ customTranslateValue('lang|', v) }}</span>
        <span *ngIf="field.key !== 'format' && !field.key.toLowerCase().includes('lang')">{{ v }}</span>
      </ng-container>
    </ng-container>
    <ng-template #scalar>
      <span *ngIf="field.key === 'format'">{{ customTranslateValue('material-type.', field.value) }}</span>
      <span *ngIf="field.key.toLowerCase().includes('lang')">{{ customTranslateValue('lang|', field.value) }}</span>
      <span *ngIf="field.key !== 'format' && !field.key.toLowerCase().includes('lang')">{{ field.value }}</span>
    </ng-template>
  </div>
</div>
<h4 class="edition-item-header" *ngIf="!isEmpty(field.header)">{{ labelFor(field.key) }}</h4>
